var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutubeinline = function SvgYoutubeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.195 2.383A2.657 2.657 0 0 0 19.32.469C17.64 0 11 0 11 0S4.32 0 2.64.469A2.657 2.657 0 0 0 .767 2.383c-.47 1.64-.47 5.156-.47 5.156s0 3.477.47 5.156c.234.938.976 1.64 1.875 1.875C4.32 15 11 15 11 15s6.64 0 8.32-.43a2.605 2.605 0 0 0 1.875-1.875c.47-1.68.47-5.156.47-5.156s0-3.516-.47-5.156Zm-12.383 8.32V4.375l5.547 3.164-5.546 3.164Z",
    fill: "currentColor"
  })));
};
export default SvgYoutubeinline;